import { z } from 'zod';

import { ResourceTriggerCriteria } from './criteria.js';

/** Only used when resourceFirstArchitectureDemo flag is on */
export const ResourceFlowTriggerSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  flowId: z.string().uuid(),
  resourceKey: z.string(),
  eventType: z.array(z.enum(['created', 'updated', 'deleted'])),
  criteria: ResourceTriggerCriteria,
  contextPaths: z.array(z.string()).nullable(),
  created: z.string().datetime(),
  updated: z.string().datetime(),
  deleted: z.string().datetime().nullable(),
});
export type ResourceFlowTrigger = z.infer<typeof ResourceFlowTriggerSchema>;

export interface CreateResourceFlowTrigger {
  flowId: string;
  organizationId: string;
  resourceKey: string;
  eventType: ('created' | 'updated' | 'deleted')[];
  contextPaths?: string[] | null;
}

export interface ResourceFlowTriggerFindAllOptions {
  flowId: string;
}
